import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.modal-container {
    font-size: 16px;
    padding: 0;
    min-width: 160px;
    margin: 10px;
}
.modal-header {
    display: flex;
    justify-content: space-between;
    height: 40px;
}
.modal-title {
  font-family: 'Nimbus Sans Light', sans-serif;
  font-weight: normal;
    font-size: 20px;
    margin-bottom: 0;
    margin-top: 0;
}
.modal-header,
.modal-title {
    margin-top: auto;
    margin-bottom: auto;
}
.modal-row {
    display: flex;
    height: 40px;
    align-items: center;
}
.modal-container > div:nth-last-of-type(2) {
    margin-bottom: 4px;
}
.add-new-icon {
    width: 18px;
    height: 18px;
    -webkit-transform: scale(0.75);
            transform: scale(0.75);
}
.close-icon {
    width: 18px;
    height: 18px;
    -webkit-transform: scale(0.75);
            transform: scale(0.75);
}
.selected-check {
    width: 18px;
    height: 18px;
    -webkit-transform: scale(0.75);
            transform: scale(0.75);
}
.watchlist-button {
    margin-left: calc(
        18px + 8px
    );
}
.watchlist-button.add-fund-button {
    margin-left: 0;
}
label.watchlist-button.add-fund-button {
    color: #000000;
    display: grid;
    grid-template-columns: 1em auto;
    gap: 0.5em;
}
.modal-bottom-row {
    border-top: 1px solid #bbbbbb;
    display: flex;
    height: 44px;
}
.add-new-button {
    display: flex;
    margin-left: 8px;
    align-items: center;
}
.selected .watchlist-button {
    display: flex;
    margin-left: 8px;
    align-items: center;
}
.new-text {
    margin-left: 8px;
}
`;

export default styles;